// -------------------
// Mapbox Locations ==
// -------------------

// @ts-expect-error
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding'

export default async (query: string) => {
  // Initialize client
  const config = useRuntimeConfig()
  const mapBoxClient = mbxGeocoding({ accessToken: config.public.mapboxAccessToken })
  // Set items
  return await mapBoxClient.forwardGeocode({
    query,
    types: ['place'],
    language: ['en']
  })
    .send()
    .then((response: any) => response.body.features)
}
